(() => {
  document.querySelectorAll('.dhuni-home-slideshow').forEach((section) => {
    const track = section.querySelector('[data-dhuni-slideshow-track]');
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-dhuni-slideshow-slide]')];
    const dots = [...section.querySelectorAll('[data-dhuni-slideshow-dot]')];
    const prevButton = section.querySelector('[data-dhuni-slideshow-prev]');
    const nextButton = section.querySelector('[data-dhuni-slideshow-next]');
    const playbackButton = section.querySelector('[data-dhuni-slideshow-playback]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reducedMotion.matches;
    let hovering = false;
    let focused = false;

    if (slides.length < 2) {
      section.setAttribute('data-single', '');
    }
    if (!slides.length) return;

    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    const videos = slides.map((slide) => slide.querySelector('video'));
    videos.forEach((video) => {
      if (!video) return;
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      video.addEventListener('error', () => video.classList.remove('is-playing'));
    });

    const syncVideos = (restart = false) => {
      videos.forEach((video, i) => {
        if (!video) return;
        if (i !== index || paused || document.hidden) {
          video.pause();
          return;
        }
        const source = mobile.matches ? video.dataset.videoMobile : video.dataset.videoDesktop;
        if (video.getAttribute('src') !== source) {
          video.classList.remove('is-playing');
          video.src = source;
          video.load();
        }
        if (restart) video.currentTime = 0;
        video.muted = true;
        video.play().catch(() => video.classList.remove('is-playing'));
      });
    };

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        slide.tabIndex = i === index ? 0 : -1;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      syncVideos(true);
    };

    const start = () => {
      stop();
      syncVideos();
      if (!paused && !hovering && !focused && !document.hidden && slides.length > 1)
        timer = window.setInterval(() => show(index + 1), 2500);
    };
    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.index)); start(); }));
    if (prevButton) prevButton.addEventListener('click', () => { show(index - 1); start(); });
    if (nextButton) nextButton.addEventListener('click', () => { show(index + 1); start(); });

    section.addEventListener('mouseenter', () => { hovering = true; stop(); });
    section.addEventListener('mouseleave', () => { hovering = false; start(); });
    section.addEventListener('focusin', () => { focused = true; stop(); });
    section.addEventListener('focusout', (event) => {
      focused = section.contains(event.relatedTarget);
      start();
    });
    const updatePlayback = () => {
      if (!playbackButton) return;
      playbackButton.textContent = paused ? '自動再生を開始' : '自動再生を停止';
      playbackButton.setAttribute('aria-pressed', String(paused));
    };
    playbackButton?.addEventListener('click', () => {
      paused = !paused;
      updatePlayback();
      start();
    });
    mobile.addEventListener('change', () => syncVideos(true));
    reducedMotion.addEventListener('change', () => {
      paused = reducedMotion.matches;
      updatePlayback();
      start();
    });
    document.addEventListener('visibilitychange', start);

    updatePlayback();
    show(index);
    start();
  });
})();
